export type ApiResultCode = string;

export interface ApiErrorItem {
  code?: ApiResultCode;
  message?: string;
  field?: string;
  [key: string]: unknown;
}

export interface ApiResponse<TContent = unknown> {
  data?: TContent;
  meta?: unknown;
  errors?: ApiErrorItem[] | null;
  message?: string;
  [key: string]: unknown;
}

export interface ApiError {
  status: number;
  code: ApiResultCode;
  resultCode: ApiResultCode;
  message: string;
  data: unknown;
  [key: string]: unknown;
}

interface HistoricalApiResponse<TContent = unknown> extends ApiResponse<TContent> {
  resultCode?: ApiResultCode;
  resultContent?: TContent;
}

export function getApiData<TContent>(response: ApiResponse<TContent>, fallback: TContent): TContent;
export function getApiData<TContent>(response: ApiResponse<TContent>): TContent | undefined;
export function getApiData<TContent>(
  response: ApiResponse<TContent>,
  fallback?: TContent
): TContent | undefined {
  const historical = response as HistoricalApiResponse<TContent>;

  if (typeof response.data !== "undefined") {
    return response.data;
  }

  if (typeof historical.resultContent !== "undefined") {
    return historical.resultContent;
  }

  return fallback;
}

export function getApiErrorCode(error: Pick<ApiError, "code" | "resultCode" | "data">): string {
  const data = error.data && typeof error.data === "object" ? (error.data as ApiResponse) : null;
  const firstError = Array.isArray(data?.errors) ? data?.errors?.[0] : null;

  return error.code || error.resultCode || firstError?.code || "NETWORK_ERROR";
}

export function getApiErrorDetails(error: ApiError): unknown {
  const data =
    error.data && typeof error.data === "object" ? (error.data as HistoricalApiResponse) : null;
  const firstError = Array.isArray(data?.errors) ? data?.errors?.[0] : null;

  return firstError?.message || data?.resultContent || error.message;
}

export interface Pagination<TItem = unknown> {
  total?: number;
  page?: number;
  pagesize?: number;
  result?: TItem[];
}

export interface DocumentLibraryReference {
  parentSlug: string;
  entrySlug: string;
}

export type DocumentLibraryParam = string | DocumentLibraryReference;

export interface LoginCredentials {
  username: string;
  password: string;
}

export interface UpdateProfilePayload {
  first_name?: string;
  last_name?: string;
  password?: string;
}

export interface UpdateParametersPayload {
  allow_email?: boolean | number;
  allow_notification?: boolean | number;
  display_notification?: boolean | number;
  language?: string;
  password?: string;
  passwordConfirm?: string;
}

export interface NotificationPayload {
  id: number | string;
  [key: string]: unknown;
}

export interface DelegateUserPayload {
  [key: string]: unknown;
}
